import React, { useState, useEffect } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Button, NativeSelect, Paper, Checkbox } from '@material-ui/core';
import MaterialTable from 'material-table';
import * as S from './styles';
import api from '../../../../services/api';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useMessageBox } from '../../../../context/MessageBox';
import { ConfirmationBox } from '../../../../components/ConfirmationBox';
import excelIcon from '../../../../assets/images/excel48.png';
import pdfIcon from '../../../../assets/images/pdf.png';
import * as FormStyle from './formStyle';
import { capitalizeFirstLetter } from '../../../../utils/functions';
import AnchorsLogoOptions from './AnchorsLogoOptions';

function OperationsMiddle({
  selectedAnchor,
  setTableData,
  setTotalTableData,
  setOnlyApproved,
  setIsLoading,
  isLoading,
  triggerUpdate,
  setTriggerUpdate,
  anchors,
  handleSelectAnchor
}) {
  const classes = FormStyle.useStyles();
  const { periodo, date } = useParams();
  const [onlyApproved, setOnlyApprovedInternal] = useState(false);

  const convertDateParams = () => {
    const dateSplit = date.split('-');

    if (dateSplit.length === 3 && Number(dateSplit[0]) > 0 && Number(Number(dateSplit[1])) >= 0
      && Number(Number(dateSplit[2])) >= 0) {
      return new Date(Number(dateSplit[2]), Number(dateSplit[1]) - 1, Number(dateSplit[0]));
    } else {
      return new Date();
    }
  }

  const [scheduleDate, setScheduleDate] = useState(date ? convertDateParams() : new Date());
  const [report, setReport] = useState();
  const [corporate, setCorporate] = useState('Todos');
  const [destinoPagamento, setDestinoPagamento] = useState("0");
  const [destinoOpcoes, setDestinoOpcoes] = useState([]);
  const [fechamentoMes, setFechamentoMes] = useState();
  const [somenteFechados, setSomenteFechados] = useState('Todos')
  const [mostrarIgnorados, setMostrarIgnorados] = useState('Todos')
  const [confirmationBox, setConfirmationBox] = useState({
    show: false,
    type: '',
    callback: () => { },
  });
  const [increase, setIncrease] = useState(0);
  const [screenParams, setScreenParams] = useState({
    title: periodo === 'diario' ? 'Relatório Diário' : 'Relatório Mensal',
    apiTable:
      periodo === 'diario' ? 'Relatorios/Relatorio003Diario' : 'Relatorios/Relatorio004Mensal',
    fechamentoMensal: 'Relatorios/Relatorio004MensalFechamentoMes',
    apiDownload:
      periodo === 'diario'
        ? 'Relatorios/Relatorio003DiarioDownloadPDF'
        : 'Relatorios/Relatorio004MensalDownloadPDF',
    apiDownloadExcel:
      periodo === 'diario'
        ? 'Relatorios/Relatorio003DiarioDownloadExcel'
        : 'Relatorios/Relatorio004MensalDownloadExcel',
    checkBox: false,
    dateFormat: periodo === 'diario' ? 'dd/MM/yyyy' : 'MM/yyyy',
  });

  const { setMessageData } = useMessageBox();

  useEffect(async () => {
    if (selectedAnchor && triggerUpdate && destinoPagamento) {
      await getInfoForForm();
    }
  }, [scheduleDate, selectedAnchor, onlyApproved, destinoPagamento, somenteFechados, mostrarIgnorados, corporate]);

  useEffect(() => {
    const initialize = async () => {
      await fetchDestinoPagamentos();
    };
    initialize();
  }, []);

  const fetchDestinoPagamentos = async () => {
    setIsLoading(true);

    try {
      const destinos = await api.get('DestinosPagamentos/Consultar?status=Ativo')
      if (destinos && destinos.data && destinos.data.status == 'Sucesso') {
        setDestinoOpcoes(destinos.data.resposta)
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }

  const getInfoForForm = async () => {
    let model = {};
    if (periodo === 'mensal') {
      model = {
        ancoraId: selectedAnchor.ancoraId,
        plataformaId: selectedAnchor.plataformaId,
        mesPagamento: new Date(scheduleDate).getMonth() + 1,
        anoPagamento: new Date(scheduleDate).getFullYear(),
        destinoPagamentoId: Number(destinoPagamento),
        filtroMostrarIgnorados: mostrarIgnorados,
        filtroPersonalizado: corporate
      };
    } else {
      model = {
        dataPagamento: new Date(scheduleDate).toISOString(),
        comissionamentoCapittale: "Comissionado",
        ancoraId: selectedAnchor.ancoraId ? selectedAnchor.ancoraId : 0,
        plataformaId: selectedAnchor.plataformaId ? selectedAnchor.plataformaId : 0,
        filtroSomenteFechados: somenteFechados,
        filtroMostrarIgnorados: mostrarIgnorados,
        filtroPersonalizado: corporate,
        incremento: increase,
        destinoPagamentoId: Number(destinoPagamento),
      }
    }
    setReport(model);
    setIsLoading(true);
    try {
      const relatorio = await api.post(screenParams.apiTable, model);

      setTableData(relatorio.data.resposta?.itens);
      setFechamentoMes(relatorio.data.resposta);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (periodo !== 'mensal') {
        // Resetar a data do calendaraio sem atualizar o relatório
        if (relatorio?.data?.resposta?.dataPagamento) {
          setTriggerUpdate(false);
          setScheduleDate(new Date(relatorio?.data?.resposta?.dataPagamento));
        }
      }

      if (relatorio.data.status !== 'Sucesso') {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }

        setIsLoading(false);
      } else {
        setTotalTableData(relatorio.data.resposta.totalizador);
        setOnlyApproved(onlyApproved);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const exportTable = async (pdf) => {
    setIsLoading(true);

    try {
      const url = pdf ? screenParams.apiDownload : screenParams.apiDownloadExcel;
      const relatorio = await api.post(url, report);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== 'Sucesso') {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      const a = document.createElement('a');
      a.href =
        'data:' +
        relatorio.data.resposta.contentType +
        ';base64,' +
        relatorio.data.resposta.fileContents;
      a.download = relatorio.data.resposta.fileDownloadName;
      a.click();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const sendOperation = async () => {
    setIsLoading(true);
    const resp = await api.post(screenParams.fechamentoMensal, report);
    const relatorio = await api.post(screenParams.apiTable, report);
    setIsLoading(false);
    if (resp?.data?.complemento?.mensagensBox?.length > 0) {
      setMessageData(resp?.data?.complemento?.mensagensBox);
      setFechamentoMes(relatorio.data.resposta);
    } else {
      toast.error('Ocorreu um erro ao enviar o fechamento!');
    }
  };

  const handleConfirmationBox = (type, callback) => {
    setConfirmationBox({
      show: true,
      type,
      callback,
    });
  };

  const htmlDecode = (input) => {
    const e = document.createElement('div');
    e.innerHTML = '<span>' + input + '</span>';
    return e.childNodes.length === 0 ? '' : e.childNodes[0].innerHTML;
  };

  return (
    <>
      {confirmationBox.show && (
        <ConfirmationBox
          data={confirmationBox}
          setConfirmationBox={setConfirmationBox}
        ></ConfirmationBox>
      )}
      <div style={{ height: '100%' }}>
        <div
          className="new-body-schedule"
          style={{ justifyContent: 'space-between', display: 'flex', marginTop: '20px', alignItems: 'center' }}
        >
          <div style={{ minWidth: '20%' }}>
            <AnchorsLogoOptions
              anchors={anchors}
              handleSelectAnchor={handleSelectAnchor}
              selectedAnchor={selectedAnchor}
            />
          </div>

          <div className="schedule-input"
            style={{ display: 'flex', marginTop: '8px', alignItems: 'center',  flexDirection: 'column' }
          }>
            <span className={classes.label}>{periodo !== 'diario' ? 'Mês do Pagamento:' : 'Data de Pagamento'} </span>
            <div style={{ display: "flex", alignItems: 'center' }}>
              <Button
                style={{ minWidth: '20px', width: '20px', height: '23px', paddingLeft: '20px' }}
                onClick={() => {
                  const newDate = new Date(scheduleDate);
                  if (periodo === 'diario') {
                    setScheduleDate(newDate.setDate(newDate.getDate() - 1));
                    setIncrease(-1);
                    setTriggerUpdate(true);
                  } else {
                    setScheduleDate(newDate.setMonth(newDate.getMonth() - 1));
                    setIncrease(-1);
                    setTriggerUpdate(true);
                  }
                }}
              >
                🢀
              </Button>

              <div style={{ padding: '0px 5px', maxWidth: '150px', height: '23px' }}>
                <DatePicker
                  style={{ width: '145px' }}
                  selected={scheduleDate}
                  onChange={(date) => {
                    setScheduleDate(date);
                    setIncrease(0);
                    setTriggerUpdate(true);
                  }}
                  dateFormat={screenParams.dateFormat}
                  locale="ptBR"
                />
              </div>

              <Button
                style={{ minWidth: '20px', width: '20px', height: '23px' }}
                onClick={() => {
                  const newDate = new Date(scheduleDate);
                  if (periodo === 'diario') {
                    setScheduleDate(newDate.setDate(newDate.getDate() + 1));
                    setIncrease(+1);
                    setTriggerUpdate(true);
                  } else {
                    setScheduleDate(newDate.setMonth(newDate.getMonth() + 1));
                    setIncrease(+1);
                    setTriggerUpdate(true);
                  }
                }}
              >
                🢂
              </Button>
            </div>
            
          </div>
          {periodo === 'diario' && (
            <div>
              <label className={classes.label}>Somente Fechados</label>
              <Paper className={classes.medium} elevation={0}>
                <NativeSelect
                  name="destinoPagamentos"
                  className={classes.input}
                  onChange={(e) => {
                    setSomenteFechados(e.target.value)
                    setTriggerUpdate(true);
                  }}
                  value={somenteFechados}
                >
                  <option value="Todos">Todos</option>
                  <option value="Fechados">Fechados</option>
                  <option value="Abertos">Abertos</option>
                </NativeSelect>
              </Paper>
          </div>
          )}

          <div>
            <label className={classes.label}>Destino de Pagamentos</label>
            <Paper className={classes.medium} elevation={0}>
              <NativeSelect
                name="destinoPagamentos"
                className={classes.input}
                onChange={(e) => {
                  setDestinoPagamento(e.target.value)
                  setTriggerUpdate(true);
                }}
                value={destinoPagamento}
              >
                <option value="0">Consolidado</option>
                {destinoOpcoes.map((destino) => (
                  <option key={destino.destinoPagamentoId} value={destino.destinoPagamentoId}>
                    {capitalizeFirstLetter(destino.destinoPagamento)}
                  </option>
                ))}
              </NativeSelect>
            </Paper>
          </div>

         <div>
            <label className={classes.label}>Mostrar Ignorados</label>
            <Paper className={classes.medium} elevation={0}>
              <NativeSelect
                name="destinoPagamentos"
                className={classes.input}
                onChange={(e) => {
                  setMostrarIgnorados(e.target.value)
                  setTriggerUpdate(true);
                }}
                value={mostrarIgnorados}
              >
                <option value="Todos">Todos</option>
                <option value="Ignorados">Ignorados</option>
                <option value="NaoIgnorados">Não Ignorados</option>
              </NativeSelect>
            </Paper>
          </div>

          <div style={{ maxWidth: 200 }}>
            <label className={classes.label}>Personalizado</label>
            <Paper className={classes.medium} elevation={0}>
              <NativeSelect
                name="corporate"
                className={classes.input}
                onChange={(e) => {
                  setCorporate(e.target.value)
                  setTriggerUpdate(true);
                }}
                value={corporate}
              >
              <option value="Todos">Todos</option>       
              <option value="Corporate">Corporate</option>
              <option value="NaoCorporate">Não Corporate</option>
              <option value="Comissionado">Comissionado</option>
              <option value="NaoComissionado">Não Comissionado</option>
              <option value="CorporateComissionado">Corporate Comissionado</option>
              <option value="CorporateNaoComissionado">Corporate Não Comissionado</option>
              </NativeSelect>
            </Paper>
          </div>

          <div
            style={
              screenParams.checkBox ? { display: 'block', marginTop: '8px' } : { display: 'none' }
            }
          >
            <input
              checked={onlyApproved}
              type="checkbox"
              onChange={(e) => {
                setOnlyApprovedInternal(e.target.checked);
              }}
            />
            <span>Somente aprovadas</span>
          </div>
          <div>
            <img
              src={excelIcon}
              onClick={() => {
                exportTable(false);
              }}
              style={{ cursor: 'pointer', marginRight: '8px' }}
            ></img>
            <img
              src={pdfIcon}
              onClick={() => {
                exportTable(true);
              }}
              style={{ cursor: 'pointer', marginBottom: '4px' }}
              width="40"
            ></img>
          </div>
        </div>
      </div>
    </>
  );
}

export default OperationsMiddle;
